import { Injectable } from '@angular/core';
import { APIService } from '../api/api.service';
@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private apiService: APIService) {}

  getDashboardStatistics(params: string) {
    let url = '/admin/dashboard';
    if (params) {
      url += `?${params}`;
    }
    return this.apiService.getWithAuthHandler(
      url,
      true,
      'getDashboardStatistics'
    );
  }
}
